export type BrandTile = {
    name: string;
    logo: string;
};

export const BRAND_TILES: Record<
    | 'citroen'
    | 'daf'
    | 'daimler'
    | 'fiat'
    | 'iveco'
    | 'koegel'
    | 'krone'
    | 'man'
    | 'mercedesBenz'
    | 'nissan'
    | 'opel'
    | 'peugeot'
    | 'renault'
    | 'renaultTrucks'
    | 'scania'
    | 'schmitzCargobull'
    | 'schwarzmueller'
    | 'volkswagen'
    | 'volvo'
    | 'wielton',
    BrandTile
> = {
    citroen: {
        logo: 'logo_citroen.svg',
        name: 'Citroen',
    },
    daf: {
        logo: 'logo_daf.svg',
        name: 'DAF',
    },
    daimler: {
        logo: 'logo_mercedes_benz_truck.svg',
        name: 'Daimler',
    },
    fiat: {
        logo: 'logo_fiat.svg',
        name: 'Fiat',
    },
    iveco: {
        logo: 'logo_iveco.svg',
        name: 'IVECO',
    },
    koegel: {
        logo: 'logo_koegel.svg',
        name: 'Kögel',
    },
    krone: {
        logo: 'logo_krone.svg',
        name: 'Krone',
    },
    man: {
        logo: 'logo_man.svg',
        name: 'MAN',
    },
    mercedesBenz: {
        logo: 'logo_mercedes_benz.svg',
        name: 'Mercedes-Benz',
    },
    nissan: {
        logo: 'logo_nissan.svg',
        name: 'Nissan',
    },
    opel: {
        logo: 'logo_opel.svg',
        name: 'Opel',
    },
    peugeot: {
        logo: 'logo_peugeot.svg',
        name: 'Peugeot',
    },
    renault: {
        logo: 'logo_renault.svg',
        name: 'Renault',
    },
    renaultTrucks: {
        logo: 'logo_renault_trucks.svg',
        name: 'Renault',
    },
    scania: {
        logo: 'logo_scania.svg',
        name: 'Scania',
    },
    schmitzCargobull: {
        logo: 'logo_schmitz_cargobull.svg',
        name: 'Schmitz Cargobull',
    },
    schwarzmueller: {
        logo: 'logo_schwarzmueller.svg',
        name: 'Schwarzmüller',
    },
    volkswagen: {
        logo: 'logo_vw.svg',
        name: 'VW',
    },
    volvo: {
        logo: 'logo_volvo.svg',
        name: 'Volvo',
    },
    wielton: {
        logo: 'logo_wielton.svg',
        name: 'Wielton',
    },
};
export const ALL_BRAND_TILES = Object.values(BRAND_TILES);
